/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdmissionWindowDto } from '../models/AdmissionWindowDto';
import type { AdmissionWindowSummaryProjection } from '../models/AdmissionWindowSummaryProjection';
import type { CreateAdmissionWindowRequest } from '../models/CreateAdmissionWindowRequest';
import type { OpenAdmissionWindowDetailsResponse } from '../models/OpenAdmissionWindowDetailsResponse';
import type { Page_AdmissionWindowDto_ } from '../models/Page_AdmissionWindowDto_';
import type { UpdateAdmissionWindowRequest } from '../models/UpdateAdmissionWindowRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdmissionWindowControllerService {
  /**
   * getAdmissionWindows
   * @returns Page_AdmissionWindowDto_ OK
   * @throws ApiError
   */
  public static getAdmissionWindowsUsingGet({
    limit,
    offset,
    search,
    status,
  }: {
    limit?: number;
    offset?: number;
    /**
     * search
     */
    search?: string;
    /**
     * status
     */
    status?: 'DRAFT' | 'PUBLISHED';
  }): CancelablePromise<Page_AdmissionWindowDto_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admission-windows',
      query: {
        limit: limit,
        offset: offset,
        search: search,
        status: status,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * createAdmissionWindow
   * @returns AdmissionWindowDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createAdmissionWindowUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: CreateAdmissionWindowRequest;
  }): CancelablePromise<AdmissionWindowDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/admission-windows',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateAdmissionWindow
   * @returns AdmissionWindowDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateAdmissionWindowUsingPut({
    request,
  }: {
    /**
     * request
     */
    request: UpdateAdmissionWindowRequest;
  }): CancelablePromise<AdmissionWindowDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/admission-windows',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getOpenAdmissionDetails
   * @returns OpenAdmissionWindowDetailsResponse OK
   * @throws ApiError
   */
  public static getOpenAdmissionDetailsUsingGet({
    admissionWindowId,
  }: {
    /**
     * admissionWindowId
     */
    admissionWindowId: string;
  }): CancelablePromise<OpenAdmissionWindowDetailsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admission-windows/open-admission-details/{admissionWindowId}',
      path: {
        admissionWindowId: admissionWindowId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getOpenAdmissions
   * @returns AdmissionWindowSummaryProjection OK
   * @throws ApiError
   */
  public static getOpenAdmissionsUsingGet(): CancelablePromise<
    Array<AdmissionWindowSummaryProjection>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admission-windows/open-admissions',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getAdmissionWindow
   * @returns AdmissionWindowDto OK
   * @throws ApiError
   */
  public static getAdmissionWindowUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<AdmissionWindowDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admission-windows/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteAdmissionWindow
   * @returns any OK
   * @throws ApiError
   */
  public static deleteAdmissionWindowUsingDelete({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/admission-windows/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
